import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { AncillaryGroundServicesImporterContainer } from './importer';

export interface AncillaryGroundServicesRoutingProps extends RouteComponentProps {}

export const AncillaryGroundServicesRouting = (props: AncillaryGroundServicesRoutingProps) => {
  return (
    <Switch>
      <Route
        path={[`${props.match.path}/`, `${props.match.path}`]}
        component={AncillaryGroundServicesImporterContainer}
      />
    </Switch>
  );
};

export const RateBreakRouting = compose(withRouter)(AncillaryGroundServicesRouting);
